/* TD 2026-10-12 UX-ACC — accessory design round (Felix 12.10.2026), the small runtime part.
   Loaded once by sections/main-product.liquid (deferred, outside <product-rerender>). Does nothing on pages without
   the markers below, so blanket pages are unaffected.
   #4 Step-row links: a block marker [data-td-acc-size] (size table, snippets/td-acc-size-table.liquid) or
      [data-td-acc-sys] ('Welches System habe ich?', snippets/td-acc-sys-help.liquid) names an option position; the link
      goes into the step row (.variant-picker__option-info) of that option, like 'Gewichtshilfe' on the blanket pages.
      The variant picker is re-rendered on every option change (Prestige partial re-render), so the links are put back
      after each re-render (MutationObserver on the product-rerender element).
   #4 Size table: the row of the selected size follows the choice. */
(() => {
  'use strict';

  const LINK_CLASS = 'td-acc-steplink';

  function optionInfo(scope, pos) {
    const fieldset = scope.querySelector('.td-variant-picker fieldset[data-td-option-position="' + pos + '"]');
    return fieldset ? fieldset.querySelector('.variant-picker__option-info') : null;
  }

  function addLink(info, key, build) {
    if (!info || info.querySelector('.' + LINK_CLASS + '[data-key="' + key + '"]')) return;
    const el = build();
    el.classList.add('link', 'td-weight-helper__link', LINK_CLASS);
    el.dataset.key = key;
    info.classList.add('td-acc-steprow'); // lets the row wrap (assets/td-ux-acc.css), so the link never overflows
    info.appendChild(el);
  }

  function syncSizeRows(table) {
    const pos = table.dataset.optionPosition;
    const scope = table.closest('.product-info') || document;
    const checked = scope.querySelector('.td-variant-picker input[type="radio"][data-option-position="' + pos + '"]:checked');
    if (!checked) return;
    const value = checked.dataset.optionValue;
    table.querySelectorAll('tbody tr').forEach((row) => {
      row.classList.toggle('is-selected', row.dataset.value === value);
    });
  }

  function apply(root) {
    root.querySelectorAll('[data-td-acc-size]').forEach((table) => {
      const scope = table.closest('.product-info') || root;
      addLink(optionInfo(scope, table.dataset.optionPosition), 'size-' + table.id, () => {
        const a = document.createElement('a');
        a.href = '#' + table.id;
        a.textContent = table.dataset.steplink || '';
        a.addEventListener('click', (event) => {
          event.preventDefault();
          table.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          table.focus({ preventScroll: true });
        });
        return a;
      });
      syncSizeRows(table);
    });

    root.querySelectorAll('[data-td-acc-sys]').forEach((marker) => {
      const scope = marker.closest('.product-info') || root;
      const modalId = marker.dataset.modal;
      if (!modalId || !document.getElementById(modalId)) return;
      addLink(optionInfo(scope, marker.dataset.optionPosition), 'sys-' + modalId, () => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-controls', modalId);
        b.setAttribute('aria-expanded', 'false');
        b.textContent = marker.dataset.steplink || '';
        return b;
      });
    });
  }

  function init() {
    if (!document.querySelector('[data-td-acc-size], [data-td-acc-sys]')) return;
    apply(document);

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply(document);
        watch(); // a full re-render (product change) replaces the product-rerender element itself
      });
    });
    function watch() {
      observer.disconnect();
      document.querySelectorAll('product-rerender').forEach((el) => {
        observer.observe(el, { childList: true, subtree: true });
        if (el.parentElement) observer.observe(el.parentElement, { childList: true });
      });
    }
    watch();

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.closest('.td-variant-picker')) return;
      document.querySelectorAll('[data-td-acc-size]').forEach(syncSizeRows);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
